// copy-on-dblclick.directive.ts
import { Directive, HostListener, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

@Directive({
  selector: '[appCopyOnDblclick]',
  standalone: true,
})
export class CopyOnDblclickDirective {
  @Input('appCopyOnDblclick') copyText: unknown;

  constructor(private clipboard: Clipboard, private snack: MatSnackBar) {}

  @HostListener('dblclick', ['$event'])
  onDblClick(ev: MouseEvent) {
    const el = ev.target as HTMLElement;
    const raw = this.copyText ?? el?.innerText ?? el?.textContent ?? '';
    const text = this.toText(raw).trim();
    if (!text) return;
    this.clipboard.copy(text);
    this.snack.open('Copied', undefined, { duration: 1200 });
  }

  private toText(v: unknown): string {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'number' || typeof v === 'boolean' || typeof v === 'bigint') return String(v);
    try { return JSON.stringify(v); } catch { return String(v); }
  }
}
